import React, { useState, useCallback } from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import MissingFlightsTable from "./tables/MissingTransfersTable.jsx";
import TransfersTable from "./tables/TransfersTable.jsx";
import "../css/Residents.css";
import useMissingTransfers from "../../shared utils/UseMissingTransfers.js";
import useCampuses from "../hooks/useCampuses.js";
import useTransfersByDate from "../hooks/useTransfersByDate.js";
import useFlights from "../hooks/useFlights.js";
import Arrivals from "./tables/Arrivals.jsx";
import Departures from "./tables/Departures.jsx"

export default function TransfersPage({
  onSelectStudent,
  selectedYear,
  selectedDate,
  setSelectedDate,
}) {
  const [value, setValue] = useState("1");
  const { campuses } = useCampuses();
  const { missingFlights, internalTransfers, loading, refetch } = useMissingTransfers(selectedYear);

  const {
    arrivals,
    departures,
    lastUpdate,
    fetchDeparturesOnDate,
    fetchAndLinkArrivals,
    fetchSingleFlight,
  } = useFlights(selectedDate);

  const {
    transfers,
    loading: transfersLoading,
    refetch: refetchTransfers,
  } = useTransfersByDate(selectedDate);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const onTransferChanged = useCallback(() => {
    // keep current Transfers tab up to date
    refetchTransfers?.(selectedDate);

    // refresh Missing Transfers dataset
    refetch?.();
  }, [refetchTransfers, selectedDate, refetch]);

  return (
    <Box sx={{ width: "100%", typography: "body1", justifyContent: "center", alignItems: "center" }}>
      <TabContext value={value}>
        <Box display="flex" justifyContent="center" width="100%" sx={{ borderBottom: 1, borderColor: "divider" }}>
          <TabList variant="scrollable" scrollButtons="auto" allowScrollButtonsMobile onChange={handleChange}>
            <Tab label="Transfers" value="1" sx={{ flexGrow: 0.5, justifyContent: "center", border: 1, borderRadius: 1, mr: 0.5 }} />
            <Tab label="Arrivals" value="2" sx={{ flexGrow: 0.5, justifyContent: "center", border: 1, borderRadius: 1, mr: 0.5 }} />
            <Tab label="Departures" value="3" sx={{ flexGrow: 0.5, justifyContent: "center", border: 1, borderRadius: 1, mr: 0.5 }} />
            <Tab label={loading ? "Missing Transfers…" : "Missing Transfers"} value="4" sx={{ flexGrow: 0.5, justifyContent: "center", border: 1, borderRadius: 1, mr: 0.5 }} />
          </TabList>
        </Box>
        <TabPanel value="1">
          <TransfersTable
            selectedDate={selectedDate}
            transfers={transfers}
            fetchTransfers={refetchTransfers}
            loading={transfersLoading}
            setSelectedDate={setSelectedDate}
            selectedYear={selectedYear}
            campuses={campuses}
            onTransferChanged={onTransferChanged}
            missingFlights={missingFlights}
            internalTransfers={internalTransfers}
          />
        </TabPanel>
        <TabPanel value="2">
          <Arrivals
            jsonFlightData={arrivals}
            noFlightData
            fetchFlights={fetchAndLinkArrivals}
            ls={lastUpdate}
            fetchSingle={fetchSingleFlight}
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
          />
        </TabPanel>
        <TabPanel value="3">
          <Departures
            jsonFlightData={departures}
            noFlightData
            fetchFlights={fetchDeparturesOnDate}
            ls={lastUpdate}
            fetchSingle={fetchSingleFlight}
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
          />
        </TabPanel>
        <TabPanel value="4">
          <MissingFlightsTable
            mFlights={missingFlights}
            internalTransfers={internalTransfers}
            loading={loading}
            handleSelectStudent={onSelectStudent}
            refreshData={refetch}
            campuses={campuses}
          />
        </TabPanel>
      </TabContext>
    </Box>
  );
}
